export const REFRESH_INTERVAL = 28000;
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8088/';
export const API_TIMEOUT = 15000;
export const TOOLTIP_DATE_FORMAT = 'MMM Do, YYYY';



// WEBPACK FOOTER //
// ./src/constants.js